import { STATUS_CONFIG } from "../constants";
import "./complaintManagement.css";

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || {
    label: status,
    color: "#6B7280",
    dot: "⚪",
  };

  return (
    <span
      className="cmp-status-badge"
      style={{ "--badge-color": config.color }}
    >
      <span className="cmp-status-dot">{config.dot}</span>
      {config.label}
    </span>
  );
};

export default StatusBadge;
